import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../../App";
import Group from "../../../../Assets/Images/bgMark.png";
import Vect from "../../../../Assets/Images/Group 1124.png";
import iconMark from "../../../../Assets/Images/iconMark.png";
import { LocationContext } from "../../../../CustomHelper/Helper";
import MyVerticallyCenteredModal from "../../../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import LearningDownloadCertificate from "../LearningDownloadCertificate/LearningDownloadCertificate";
import LearningModal1 from "../LearningModal1/LearningModal1";
import LearningPayModal from "./LearningPayModal";
import "./LearningResult.css";

const LearningResult = ({ changeRoute, setChangeRoute, learningSession }) => {
  const { videoCdnUrl } = useContext(serverInfo);
  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);
  const [modalShow1, setModalShow1] = React.useState(false);
  const [modalShow2, setModalShow2] = React.useState(false);

  const [markedVideos, setMarkedVideos] = useState([]);
  const [rejectedVideos, setRejectedVideos] = useState([]);
  const [modalChange, setModalChange] = useState(0);
  const [appliedForCertificate, setAppliedForCertificate] = useState();
  const [paymentForCertificate, setPaymentForCertificate] = useState();
  const [totalMark, setTotalMark] = useState(0);

  let total = Number(totalMark / learningSession?.assignment_video_slot_number);

  useEffect(() => {
    let slug = learningSession.slug;
    axios.get(`api/learning-session/result/${slug}`).then((res) => {
      if (res.data.status === 200) {
        setMarkedVideos(res.data.markedVideos);
        setRejectedVideos(res.data.rejectedVideos);
        setPaymentForCertificate(res?.data?.paymentForCertificate);
        setAppliedForCertificate(res?.data?.appliedForCertificate);
        setTotalMark(res?.data?.totalMark);
      }
    });
  }, [learningSession, changeRoute]);

  const handleClick = () => {
    setModalShow2(true);
    setModalChange(1);
  };

  return (
    <>
      <div className="m-3">
        <div className="row ">
          <div className="card bg-custom">
            {/* <h4 className="col-md-12 text-warning pt-2 pb-2 RowAmd">Result</h4> */}
            <h1 className="titleInstruction text-center p-2 mt-2">
              Learning Session Result{" "}
            </h1>
            <hr />

            <div className="ow">
              <div className="videoPlayerSection"></div>
              <div className="row">
                {markedVideos &&
                  markedVideos?.map((video) => (
                    <div className="col-md-3 mx-auto">
                      <div className="card bg-dark mVie">
                        <ReactPlayer
                          url={videoCdnUrl + video?.video}
                          controls
                          autoplay="true"
                          className="img-fluid NamVe"
                        />
                        <img src={Group} alt="" className="bgMarkStyle" />
                        <p className="PCenterLX text-warning p-1 ">
                          <img src={iconMark} alt="" />
                        </p>
                        <p className="PCenterX text-light p-1  ">Mark</p>
                        <input
                          value={video?.mark}
                          readOnly
                          className="PCenterRX text-warning p-1 bg-dark border-0 fw-bold"
                        />
                      </div>
                    </div>
                  ))}

                {rejectedVideos &&
                  rejectedVideos?.map((video) => (
                    <div className="col-md-3 mb-5 mt-4">
                      <div className="card bg-dark mVie">
                        <ReactPlayer
                          url={videoCdnUrl + video?.video}
                          controls
                          playing={false}
                          className="img-fluid NamVe"
                        />

                        <div className="card-footer">
                          <p className="text-danger text-center p-1  ">
                            Rejected
                          </p>

                          <p className="text-light text-center">
                            {video.comment}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="videoPlayerSection mb-2"></div>
            </div>

            <div className="mb-3 mt-3 row justify-content-between BTsd p-2 mb-3 ">
              <div className="col-md-1 IMGLs d-flex justify-content-center ps-2">
                <img src={Vect} alt="" />
              </div>
              <div className="col-md-4 text-center BlackUouResult text-light YourT pt-3 fw-bold ms-3">
                Your Total Mark
              </div>
              <div className="col-md-2 BlackUou BlackUouResult ">
                <input
                  type="text"
                  value={total}
                  readOnly
                  className="from-control wIn fw-bold mt-2"
                />
              </div>
              {markedVideos && markedVideos.length > 0 ? (
                <>
                  {appliedForCertificate ? (
                    <>
                      {paymentForCertificate ? (
                        <button className="col-md-4 btnAppLearningResult text-center fw-bold text-dark py-1">
                          Paid
                        </button>
                      ) : (
                        <button
                          onClick={handleClick}
                          className="col-md-4 btnAppLearningResult text-center fw-bold text-dark py-1"
                          disabled={payStatus ? false : true}
                        >
                          Pay Now
                          {" " +
                            paymentCountWithSymbol(
                              learningSession?.assignment_fee
                            )}
                        </button>
                      )}
                    </>
                  ) : (
                    <button
                      onClick={() => setModalShow1(true)}
                      className="col-md-4 btnAppLearningResult text-center fw-bold text-dark py-1"
                    >
                      Apply for the certificate
                    </button>
                  )}
                </>
              ) : (
                <>
                  <button className="col-md-4 btnAppLearningResult text-center fw-bold text-dark py-1">
                    Please Wait For Result
                  </button>
                </>
              )}
            </div>
            {paymentForCertificate || learningSession.assignment_fee === 0 && appliedForCertificate ? (
              <LearningDownloadCertificate learningSession={learningSession} />
            ) : (
              <></>
            )}

            {modalChange === 0 && (
              <LearningModal1
                changeRoute={changeRoute}
                setChangeRoute={setChangeRoute}
                modalChange={modalChange}
                setModalChange={setModalChange}
                show={modalShow1}
                setModalShow1={setModalShow1}
                learningSession={learningSession}
              />
            )}

            {modalChange === 1 && (
              <MyVerticallyCenteredModal
                show={modalShow2}
                onHide={() => setModalShow2(false)}
                event_id={learningSession?.id}
                fee={paymentCount(learningSession?.assignment_fee)}
                baseFee={learningSession?.assignment_fee}
                event_type="learningCertificate"
                redirectTo="activities"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LearningResult;
